import * as R from 'ramda';
import { connect } from 'react-redux';
import { compose, lifecycle, mapProps } from 'recompose';

import {
  handleOrganizationSettingsFetch,
} from '../redux/thunk/organization-settings';

export const withOrganizationSettings = compose(
  connect(null, {
    handleOrganizationSettingsFetch,
  }),

  lifecycle({
    componentDidMount() {
      const { previewToken } = this.props;

      if (previewToken) {
        // do something
      } else {
        this.props.handleOrganizationSettingsFetch();
      }
    },
  }),

  mapProps(R.omit(['handleOrganizationSettingsFetch'])),
);



// WEBPACK FOOTER //
// ./src/layouts/common.js